import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store'
import { getUserUniqueId } from './utils/uniqueId'

import {
  Button,
  Field,
  Form,
  Cell,
  CellGroup,
  Popup,
  Dialog,
  Toast,
  Notify,
  NavBar,
  Tabs,
  Tab,
  Empty,
  Icon,
  Image as VanImage,
  Popover,
  ActionSheet,
  Sidebar,
  SidebarItem,
  Search,
  Col,
  Row,
  List,
  PullRefresh,
  Overlay
} from 'vant'

Vue.use(Button)
Vue.use(Field)
Vue.use(Form)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Notify)
Vue.use(NavBar)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Empty)
Vue.use(Icon)
Vue.use(VanImage)
Vue.use(Popover)
Vue.use(ActionSheet)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Search)
Vue.use(Col)
Vue.use(Row)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Overlay)

Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$notify = Notify

getUserUniqueId()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
